<template>
	<ul class="list-unstyled contact-social">
		<li v-if="contact.Linkedin || contact.linkedin">
			<a
				:href="contact.Linkedin || contact.linkedin"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'linkedin-in']" />
			</a>
		</li>
		<li v-if="contact.Instagram || contact.instagram">
			<a
				:href="contact.Instagram || contact.instagram"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'instagram']" />
			</a>
		</li>
		<li v-if="contact.Facebook || contact.facebook">
			<a
				:href="contact.Facebook || contact.facebook"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'facebook-round']" />
			</a>
		</li>
		<li v-if="contact.Pinterest || contact.pinterest">
			<a
				:href="contact.Pinterest || contact.pinterest"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'pinterest']" />
			</a>
		</li>
		<li v-if="contact.Twitter || contact.twitter">
			<a
				:href="contact.Twitter || contact.twitter"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'twitter']" />
			</a>
		</li>
		<li v-if="contact.Tiktok">
			<a :href="contact.Tiktok" target="_blank" rel="noopener">
				<font-awesome-icon :icon="['custom', 'tiktok']" />
			</a>
		</li>
		<li v-if="contact.Snapchat">
			<a :href="contact.Snapchat" target="_blank" rel="noopener">
				<font-awesome-icon :icon="['custom', 'snapchat']" />
			</a>
		</li>
		<li v-if="contact.Spotify">
			<a :href="contact.Spotify" target="_blank" rel="noopener">
				<font-awesome-icon :icon="['custom', 'spotify']" />
			</a>
		</li>
		<li v-if="contact.Soundcloud">
			<a :href="contact.Soundcloud" target="_blank" rel="noopener">
				<font-awesome-icon :icon="['custom', 'soundcloud']" />
			</a>
		</li>
		<li v-if="contact.Youtube">
			<a :href="contact.Youtube" target="_blank" rel="noopener">
				<font-awesome-icon :icon="['custom', 'youtube']" />
			</a>
		</li>
		<li v-if="contact.Website || contact.website">
			<a
				:href="contact.Website || contact.website"
				target="_blank"
				rel="noopener"
			>
				<font-awesome-icon :icon="['custom', 'share']" />
			</a>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'SocialMedia',
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact']
}
</script>
<style lang="scss" scoped>
.contact-social {
	display: flex;
	align-items: center;
	gap: 20px;
	a {
		color: $white;
		font-size: 1.5rem;
	}
	[data-icon='instagram'] {
		top: 2px;
		position: relative;
	}
}
.fullwidth-slider {
	.contact-social {
		a {
			color: $black;
		}
	}
}
</style>
